// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:1024px){[data-v-78c905b7] .dropdown-height{height:350px;width:350px}}.plans-view[data-v-78c905b7] .dropdown-height{height:200px;width:350px}[data-v-78c905b7] .dropdown-label{padding-right:5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
